import { getCookie } from '@beef/utils';
import { CAPTCHA_STAGE_KEY, CAPTCHA_TARGET_KEY } from "../../../../../shared/config";
import { FSMStages } from "../../../../../shared/model";
export var getStage = function getStage(fsmStage) {
  var _ref;
  if (fsmStage === FSMStages.BLOCKED) {
    return 'blocked';
  }
  return (_ref = getCookie(CAPTCHA_STAGE_KEY)) !== null && _ref !== void 0 ? _ref : 'init';
};
export var getCaptchaData = function getCaptchaData() {
  var data = sessionStorage.getItem(CAPTCHA_TARGET_KEY);
  if (!data) {
    return undefined;
  }
  return JSON.parse(data);
};
export var initChipsList = ['Списание баланса', 'Платные услуги', 'Не работает интернет', 'Смена тарифа', 'Мой тариф'];